import type { ReactNode } from 'react'

type Props = {
  title: string
  children: ReactNode
}

export default function ExpandDetails({ title, children }: Props) {
  return (
    <details className="group rounded-lg border border-outline-variant/15 bg-surface-container-low/35 open:border-primary-container/30 open:bg-surface-container-low/50">
      <summary className="cursor-pointer list-none px-4 py-3 [&::-webkit-details-marker]:hidden">
        <span className="flex items-center justify-between gap-3 font-label text-xs font-bold tracking-widest text-primary uppercase">
          <span>{title}</span>
          <span
            className="material-symbols-outlined shrink-0 text-lg text-primary-container transition-transform duration-200 group-open:rotate-180"
            aria-hidden
          >
            expand_more
          </span>
        </span>
      </summary>
      <div className="border-t border-outline-variant/10 px-4 py-4 font-body text-sm leading-relaxed text-on-surface-variant md:text-base md:leading-relaxed">
        {children}
      </div>
    </details>
  )
}
